import { AppColorContainer } from "../AppColorContainer";
import { IAppThemeFactory } from "../IAppThemeFactory";
import { DarkModeOneNoteAppColorContainer } from "./DarkModeOneNoteAppColorContainer";
import { LightModeOneNoteAppColorContainer } from "./LightModeOneNoteAppColorContainer";

// This is the OneNoteThemeFactory which will initiate AppColorContainer for Dark/Light theme in OneNote app.
export class OneNoteThemeFactory implements IAppThemeFactory {
  GetThemeColorContainer(isDarkModeEnabled : boolean) : AppColorContainer {
    if (isDarkModeEnabled) {
      return DarkModeOneNoteAppColorContainer.GetInstance();
    } else {
      return LightModeOneNoteAppColorContainer.GetInstance();
    }
  }
}